import React, { useContext } from 'react';
import { ResponsiveMode } from '@bingads-webui-campaign-react/smart-component-util';

export const defaultClientContext = {
  isMobile: false,
  responsiveMode: ResponsiveMode.LargeDesktop,
  isRuntime: false,
};

export const ClientContext = React.createContext(defaultClientContext);

export const useClientContext = () => useContext(ClientContext);
